import { api } from "../evergis/api";

export const getResourceName = () => api.names.createResourceName();
export const extractNamespace = (resource: string): string => api.names.extractResourceWorkspace(resource);
export const extractResourceName = (resource: string): string => api.names.extractResourceName(resource);
export const getTempResourceName = () => api.names.createTempResourceName();
